import { FC, useEffect, useState } from 'react';

import { useBreakpointValue, useDisclosure } from '@bonusly/design-system';
import { useEventListener } from '@bonusly/events';

import { AnnouncementsCarouselModal, AnnouncementsMobileModal } from '.';
import { useGetCurrentAnnouncements } from '../hooks/use-announcements';
import { AnnouncementActionEvent, OpenAnnouncementEvent } from '../types/events';

export const AnnouncementsModalHandler: FC = () => {
	const isMobile = useBreakpointValue({ base: true, sm: false });
	const modal = useDisclosure();
	const { data: announcements, isLoading } = useGetCurrentAnnouncements();
	const [selectedAnnouncementId, setSelectedAnnouncementId] = useState<string>();

	useEventListener(AnnouncementActionEvent.OpenAnnouncement, (event: OpenAnnouncementEvent) => {
		if (event) setSelectedAnnouncementId(event.id);
		modal.onOpen();
	});

	if (!announcements || isLoading) return null;

	return (
		<>
			{isMobile ? (
				<AnnouncementsMobileModal announcements={announcements} isOpen={modal.isOpen} onClose={modal.onClose} />
			) : (
				<AnnouncementsCarouselModal
					announcements={announcements}
					isOpen={modal.isOpen}
					onClose={modal.onClose}
					selectedAnnouncementId={selectedAnnouncementId}
				/>
			)}
		</>
	);
};
